import SectionHeading from "@/components/base/SectionHeading";
import { siteInfo, testimonials } from "@/mocks/articles";

export default function VoicesSection() {
  return (
    <section className="border-y border-background-200 bg-foreground-950">
      <div className="mx-auto max-w-editorial px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 border-b border-foreground-800 pb-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-400">
              <span className="inline-block h-3 w-0.5 bg-accent-500" aria-hidden="true"></span>
              读者与同行
            </p>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-[28px]">他们为什么持续在读</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-100/65">
            {siteInfo.name}从 {siteInfo.since} 年开始做内容复盘，编辑团队由 {siteInfo.editors.length} 位长期从事内容行业观察的作者组成。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure key={item.name} className="flex flex-col rounded-lg border border-foreground-800 bg-foreground-900 p-6">
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-loose text-background-100/85">
                <p>{item.text}</p>
              </blockquote>
              <figcaption className="mt-5 border-t border-foreground-800 pt-4">
                <span className="font-heading text-sm font-semibold text-background-50">{item.name}</span>
                <span className="ml-2 text-xs text-background-100/55">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}